import { emailValidations } from '../../../../shared_modules/local-propulsion/components';

const validator = require('ui-validator');

const isSigned = validator.createValidator((options, value) => {
  if (value !== 'on') {
    return 'Check the box to continue';
  }

  return undefined;
});

const v = validator.validators;
const allValidations = isJoint => ({
  ...emailValidations(isJoint),
  agreements: {
    required: v.required({ message: 'Check the box to continue' }),
    isSigned: isSigned(),
  },
});

const validations = (fieldName, isJoint) => {
  if (fieldName) {
    return {
      [fieldName]: allValidations(isJoint)[fieldName],
    };
  }

  return allValidations(isJoint);
};

export default validations;

